import React from "react";
import InteractiveContactPage from "../components/InteractiveContactPage";

const ContactPage = () => <InteractiveContactPage locale="en" />;

export default ContactPage;
